import React, { useState, useEffect } from 'react';
import json from '../../localization/index.json';
import { api, apiPost } from '../../Services/api';
import { Objeto } from '../../../../Services/Models';
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import moment from 'moment';
import {
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  GridComponent,
  Page,
  Inject,
  Filter,
  Group,
  ExcelExport,
  PdfExport,
  Toolbar,
  ToolbarItems,
  Grid,
  FilterSettingsModel,
  Edit,
  EditSettingsModel,
  ActionEventArgs
} from '@syncfusion/ej2-react-grids';
import './style.css'

L10n.load(json)

function App() {
  const [getProjectData, setProjectData] = useState();
  const [getData, setData] = useState<Array<Objeto.DeParaData>>([]);
  const [getLoading, setLoading] = useState<boolean>(true);
  let tabelaEmp:string;

  let preData: Array<Objeto.DeParaData> = [];
  const filterOptions: FilterSettingsModel = {
    ignoreAccent: true,
    immediateModeDelay: 200,
    mode: "Immediate",
    type: 'Excel'
  }
  let grid: Grid | null;
  const editOptions: EditSettingsModel = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', allowEditOnDblClick: true, allowNextRowEdit: true };
  const toolbarOptions: ToolbarItems[] = ['PdfExport', 'Add', 'Edit', 'Delete', 'Update', 'Cancel']
  const toolbarClick = (args: any) => {
    console.log('pre-grid')
    if (grid) {
      console.log(args.item.id)
      if (args.item.id === 'grid_pdfexport') {
        grid.pdfExport({
          fileName: `Vendas De Cessão ${moment(new Date(), true).format("YYYY-MM-DD")}.pdf`,
          pageOrientation: "Landscape",
          header: {
            fromTop: 0,
            height: 130,
            contents: [
              // {
              //   type: 'Text',
              //   value: `${getItemPickerCentroDeCusto?.descricao}`,
              //   position: { x: 390, y: 50 },
              //   style: { textBrushColor: "#000000", fontSize: 20, hAlign: "Right" },
              // },
              // {
              //   position: { x: 0, y: 45 },
              //   size: { height: 40, width: 80 },
              //   src: image,
              //   type: 'Image',
              // },
              {
                type: 'Text',
                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:MM:SS")}`,
                position: { x: 880, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 13 },
              },
            ]
          },
          footer: {
            contents: [
              {
                type: 'Text',
                value: `Powered by DigitalDEV`,
                position: { x: 0, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 10 },
              },
              {
                format: 'Página {$current} de {$total}',
                pageNumberType: "Numeric",
                position: { x: 910, y: 50 },
                style: {
                  fontSize: 13,
                  hAlign: "Right",
                  textBrushColor: '#000000',
                },
                type: 'PageNumber',
              }
            ],
            fromBottom: 0,
            height: 100,
          },
          theme: {
            header: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            },
            record: {
              bold: false,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7)
            },
            caption: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            }
          },
          allowHorizontalOverflow: false,

        });
      }
    }
  }

  useEffect(() => {
    async function componentDidMount() {
      await api.get(`/dePara?tabelaEmp=${tabelaEmp}`).then(async response => {
        await response.data.map((objeto: Objeto.DeParaData, index: number) => {
          preData.push(
            {
              NM_Empresa: objeto.NM_Empresa,
              empresa_bd: objeto.empresa_bd,
              empresa: objeto.empresa,
              Divisao: objeto.Divisao,
              chave: objeto.chave,
              NM_Obra: objeto.NM_Obra,
              KEY_CDEMP_BD: objeto.KEY_CDEMP_BD,
              KEY_CDEMP_CDOBR_BD: objeto.KEY_CDEMP_CDOBR_BD,
              Cod_Obra: objeto.Cod_Obra
            }
          )
        })
        await setProjectData(response.data)
        //console.log(response.data)
      })

      await setData(preData)
      await setLoading(false)

    }
    componentDidMount();
  }, [])

  if(localStorage.getItem("cd_emp") !== null) {
    switch(Number(localStorage.getItem("cd_emp"))) {
      case 1:
        tabelaEmp = "Rio";
        break;
      case 20: 
        tabelaEmp = "Espaco";
        break;
    }
  }

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <GridComponent
          dataSource={getData}
          id='grid'
          ref={g => grid = g}
          allowPaging={true}
          allowFiltering={true}
          pageSettings={{ pageSizes: [10, 20, 30], pageSize: 10 }}
          filterSettings={filterOptions}
          toolbarClick={toolbarClick}
          toolbar={toolbarOptions}
          allowPdfExport={true}
          editSettings={editOptions}
          actionBegin={(args: any) => {
            if (args.requestType == 'save') {
              if (args.action === 'edit') {
                if (JSON.stringify(args.previousData) !== JSON.stringify(args.data)) {
                  let listData = [...getData];
                  listData[args.rowIndex] = {
                    Cod_Obra: args.data.Cod_Obra,
                    Divisao: args.data.Divisao,
                    NM_Empresa: args.data.NM_Empresa,
                    NM_Obra: args.data.NM_Obra,
                    chave: args.data.chave,
                    empresa: args.data.empresa,
                    empresa_bd: args.data.empresa_bd,
                    KEY_CDEMP_BD: `${args.data.empresa_bd}-${args.data.empresa}`,
                    KEY_CDEMP_CDOBR_BD: `${args.data.empresa_bd}-${args.data.empresa}-${args.data.Cod_Obra}`
                  }
                  setData(listData);
                  api.post(`/dePara?tabelaEmp=${tabelaEmp}`, listData).then(() => console.log("EDIT DONE!"));
                }
                else {
                  console.log('Dados iguais!');
                }
              }
              if (args.action === 'add') {
                let listData = [...getData];
                // listData.shift()
                listData.unshift({
                  Cod_Obra: args.data.Cod_Obra,
                  Divisao: args.data.Divisao,
                  NM_Empresa: args.data.NM_Empresa,
                  NM_Obra: args.data.NM_Obra,
                  chave: args.data.chave,
                  empresa: args.data.empresa,
                  empresa_bd: args.data.empresa_bd,
                  KEY_CDEMP_BD: `${args.data.empresa_bd}-${args.data.empresa}`,
                  KEY_CDEMP_CDOBR_BD: `${args.data.empresa_bd}-${args.data.empresa}-${args.data.Cod_Obra}`
                })
                setTimeout(() => {
                  setData(listData)
                }, 2000);
                api.post(`/dePara?tabelaEmp=${tabelaEmp}`, listData).then(() => console.log("ADD DONE!"));
              }
            }
            if (args.requestType === 'delete') {
              let found = false;
              let listData = [...getData];
              //console.log(args.data);
              // console.log(listData);
              listData.map((data, dataIndex) => {
                if (!found && args.data[0].KEY_CDEMP_CDOBR_BD === data.KEY_CDEMP_CDOBR_BD) {
                  listData.splice(dataIndex, 1);
                  api.post(`/dePara?tabelaEmp=${tabelaEmp}`, listData).then(() => {
                    console.log("DELETE DONE");
                    setData(listData);
                  });
                  found = true;
                }
              })
            }
          }}
          style={{ opacity: getLoading === true ? "0.5" : "1", pointerEvents: getLoading === true ? "none" : "auto" }}>
          <ColumnsDirective>
            <ColumnDirective field="NM_Empresa" headerText='Descrição Empresa' width='100' />
            <ColumnDirective field="NM_Obra" headerText='Descrição Obra' width='100' />
            <ColumnDirective field='empresa' headerText='empresa' width='100' />
            <ColumnDirective field='Cod_Obra' headerText='Cod Obra' width='100' />
            <ColumnDirective field='Divisao' headerText='Divisao' width='100' />
            <ColumnDirective field='chave' headerText='chave' width='100' />
            <ColumnDirective defaultValue={localStorage.getItem('cd_emp') ?? undefined} field='empresa_bd' headerText='Centro de Custo' visible={false} width='100' />
          </ColumnsDirective>
          <Inject services={[Page, Filter, Group, ExcelExport, PdfExport, Toolbar, Aggregate, Edit]} />
        </GridComponent>
      </div>
    </>
  );
}

export default App;